import { hot } from 'react-hot-loader';
import React from 'react';
import View from './View';

export { default as fetchData } from './fetchData';

const SitemapComponent = ({ data, location }) => {
  return <View data={data} location={location} />
};

export const Sitemap = hot(module)(SitemapComponent);
